import React, { useState, useEffect } from "react";
import "../css/switch.css";

interface SwitchProps {
    id: string;
    checked?: boolean;
    onChange?: (value: boolean) => void;
}

export const Switch: React.FC<SwitchProps> = ({ id, checked: checkedProp, onChange }) => {
    const [checked, setChecked] = useState<boolean>(checkedProp || false);

    useEffect(() => {
        if (checkedProp !== undefined) {
            setChecked(checkedProp);
        }
    }, [checkedProp]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.checked;
        setChecked(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <div className="checkbox-wrapper-6">
            <input
                checked={checked}
                className="tgl tgl-light"
                id={`${id}`}
                type="checkbox"
                onChange={handleChange}
            />
            <label className="tgl-btn" htmlFor={`${id}`} />
        </div>
    );
};